/**
 * Scopes a Collection or Search page to the shopper's remembered iPhone
 * model by navigating to the matching native filter value's URL - so
 * browsing a model-filterable listing (e.g. Cases) automatically narrows to
 * the remembered model, while listings with no such filter (charms, straps -
 * "fits every model"; or a search whose results have no model filter at all)
 * are naturally exempt because data-model-scope-map is never rendered for
 * them.
 *
 * DOM contract: one element on the page (sections/collection.liquid or
 * sections/search.liquid) carries `data-model-scope-map` (a JSON object of
 * {filterValueLabel: url_to_add} built server side from
 * collection.filters/search.filters), `data-model-scope-active` ("true" once
 * that filter is already applied in the current URL, in which case this
 * never overrides the shopper's own filter choice), and
 * `data-model-scope-key` (a value unique to this listing - collection handle
 * or search term - used to avoid re-navigating to the same target more than
 * once per browser session).
 */
function applyModelScope() {
  const root = document.querySelector('[data-model-scope-map]');
  if (!root || root.dataset.modelScopeActive === 'true') return;

  const model = window.localStorage.getItem('vellum:selectedModel');
  if (!model) return;

  let map;
  try {
    map = JSON.parse(root.dataset.modelScopeMap);
  } catch (error) {
    return;
  }

  const matchedKey = Object.keys(map).find((label) => label.toLowerCase() === model.toLowerCase());
  if (!matchedKey) return;

  const targetUrl = map[matchedKey];
  const syncedFlag = `vellum:modelScopeSynced:${root.dataset.modelScopeKey}:${model}`;
  if (window.sessionStorage.getItem(syncedFlag)) return;

  window.sessionStorage.setItem(syncedFlag, '1');
  window.location.href = targetUrl;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', applyModelScope);
} else {
  applyModelScope();
}

window.addEventListener('vellum:model-selected', applyModelScope);
